import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Text } from '../components/Texte';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Mail } from '../components/icons';
import { Button } from '../components/Button';
import { Card } from '../components/Card';
import { useGabarit } from '../hooks/useGabarit';
import { ScreenHeader } from '../components/ScreenHeader';
import { colors, layout, radius, screenPadding, spacing, typography } from '../theme/tokens';
import { t, tBrut } from '../i18n';
import { ouvrirLien } from '../utils/ouvrirLien';

// Adresse de contact externe réelle — NE PAS renommer (indépendante du nom de l'app).
const CONTACT_EMAIL = 'info@alternjob.com';

interface Faq {
  q: string;
  a: string;
}

// Construite AU RENDU : constante de module = libellés figés à l'import.
const faq = (): Faq[] => [
  { q: t('help.faq.ats.q'), a: t('help.faq.ats.a') },
  { q: t('help.faq.privacy.q'), a: t('help.faq.privacy.a') },
  { q: t('help.faq.coaching.q'), a: t('help.faq.coaching.a') },
];

export function HelpScreen({ onBack }: { onBack?: () => void }) {
  const contact = () => {
    ouvrirLien(
      `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(tBrut('help.mailSubject'))}`,
    );
  };

  const { large } = useGabarit();
  const sIntro = (
    <>
        <Text style={styles.intro}>
          Une question sur ton CV, tes entretiens ou le coaching ? Voici les réponses les plus fréquentes —
          et un moyen simple de nous joindre.
        </Text>

            </>
  );
  const sFaq = (
    <>
<Text style={styles.sectionLabel}>{t('help.faqSection')}</Text>
        {faq().map((item, index) => (
          <Card key={index} testID={`help-faq-${index}`}>
            <Text style={styles.question}>{item.q}</Text>
            <Text style={styles.answer}>{item.a}</Text>
          </Card>
        ))}

            </>
  );
  const sContact = (
    <>
<Text style={styles.sectionLabel}>{t('help.contactSection')}</Text>
        <Card>
          <View style={styles.contactRow}>
            <View style={styles.iconWrap}>
              <Mail size={20} color={colors.electric} strokeWidth={2} />
            </View>
            <View style={styles.contactTexts}>
              <Text style={styles.contactTitle}>{t('help.writeUs')}</Text>
              <Text style={styles.contactEmail}>{CONTACT_EMAIL}</Text>
            </View>
          </View>
          <Button title={t('help.sendEmail')} withArrow onPress={contact} testID="help-contact" />
        </Card>
    </>
  );

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <ScreenHeader onBack={onBack} title={t('help.title')} testID="help-back" />
              {large ? (
          <ScrollView contentContainerStyle={styles.colonnesL} showsVerticalScrollIndicator={false}>
            <View style={styles.colGaucheL}>
              {sIntro}
              {sFaq}
            </View>
            <View style={styles.colDroiteL}>
              {sContact}
            </View>
          </ScrollView>
        ) : (
          <ScrollView contentContainerStyle={styles.content}>
            {sIntro}
            {sFaq}
            {sContact}
          </ScrollView>
        )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  colonnesL: {
    flexGrow: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.xl,
    width: '100%',
    maxWidth: layout.pageMaxWidth,
    alignSelf: 'center',
    padding: spacing.xxl + spacing.xl,
  },
  colGaucheL: { flex: 1, minWidth: 0, gap: spacing.lg },
  colDroiteL: { flex: 1, minWidth: 0, gap: spacing.md },
  piedL: { marginTop: spacing.sm },
  container: { flex: 1, backgroundColor: colors.grey50 },
  content: { padding: screenPadding, gap: spacing.md },
  intro: { fontSize: typography.body.size, lineHeight: typography.body.lineHeight, color: colors.grey500 },
  sectionLabel: {
    marginTop: spacing.xs,
    fontSize: typography.caption.size,
    fontWeight: typography.caption.weight,
    letterSpacing: typography.caption.letterSpacing,
    color: colors.grey500,
  },
  question: { fontSize: typography.h3.size, fontWeight: typography.h3.weight, color: colors.grey900 },
  answer: { marginTop: spacing.xs, fontSize: typography.body.size, lineHeight: typography.body.lineHeight, color: colors.grey700 },
  contactRow: { flexDirection: 'row', alignItems: 'center', gap: spacing.md, marginBottom: spacing.md },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: radius.md,
    backgroundColor: colors.blueSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contactTexts: { flex: 1, gap: spacing.xs / 2 },
  contactTitle: { fontSize: typography.bodyMd.size, fontWeight: typography.bodyMd.weight, color: colors.grey900 },
  contactEmail: { fontSize: typography.small.size, color: colors.grey500 },
});
